import { supabase } from '../../eventsCalculator/lib/supabaseClient';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const TABLE = 'eventbrella-prospects';

/**
 * Insert a lead into public."eventbrella-prospects".
 * @returns {Promise<{ ok: boolean, error?: string }>}
 */
export async function submitEventbrellaProspect({ name, phone, email }) {
  if (!supabase) {
    // eslint-disable-next-line no-console
    console.error(
      '[eventbrella-prospects] Supabase not configured. Set REACT_APP_SUPABASE_URL_SALES_MASTERY and REACT_APP_SUPABASE_ANON_KEY_SALES_MASTERY.'
    );
    return { ok: false, error: 'not_configured' };
  }

  const trimmedName = String(name || '').trim();
  if (!trimmedName) {
    return { ok: false, error: 'missing_name' };
  }

  const trimmedEmail = String(email || '').trim().toLowerCase();
  if (!trimmedEmail || !EMAIL_RE.test(trimmedEmail)) {
    return { ok: false, error: 'invalid_email' };
  }

  const phoneVal =
    phone == null || String(phone).trim() === ''
      ? null
      : String(phone).trim().slice(0, 50);

  const { error } = await supabase.from(TABLE).insert({
    name: trimmedName.slice(0, 200),
    phone: phoneVal,
    email: trimmedEmail,
  });

  if (error) {
    // eslint-disable-next-line no-console
    console.error('[eventbrella-prospects] insert failed:', error.message);
    return { ok: false, error: error.message };
  }

  return { ok: true };
}
